var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisedHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 19,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5016 12.5C20.5016 11.9469 20.0547 11.5 19.5016 11.5C18.9485 11.5 18.5016 11.9469 18.5016 12.5V19C18.5016 19.275 18.2766 19.5 18.0016 19.5C17.7266 19.5 17.5016 19.275 17.5016 19V13.5C17.5016 12.9469 17.0547 12.5 16.5016 12.5C15.9485 12.5 15.5016 12.9469 15.5016 13.5V22C15.5016 22.0469 15.5016 22.0969 15.5047 22.1438L13.6141 20.3438C13.1141 19.8687 12.3235 19.8875 11.8453 20.3875C11.3672 20.8875 11.3891 21.6781 11.8891 22.1562L15.4016 25.5C16.7485 26.7844 18.5391 27.5 20.4016 27.5H21.0016C24.0391 27.5 26.5016 25.0375 26.5016 22V15.5C26.5016 14.9469 26.0547 14.5 25.5016 14.5C24.9485 14.5 24.5016 14.9469 24.5016 15.5V19C24.5016 19.275 24.2766 19.5 24.0016 19.5C23.7266 19.5 23.5016 19.275 23.5016 19V13.5C23.5016 12.9469 23.0547 12.5 22.5016 12.5C21.9485 12.5 21.5016 12.9469 21.5016 13.5V19C21.5016 19.275 21.2766 19.5 21.0016 19.5C20.7266 19.5 20.5016 19.275 20.5016 19V12.5Z",
    fill: "#3C5199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedHand);
export default __webpack_public_path__ + "static/media/raised-hand.baa3af93fbf7846a205945df712bb726.svg";
export { ForwardRef as ReactComponent };